<template>
  <div class="loginform">
    <h1>Login</h1>
    <transition name="slide">
      <div class="alert" v-if="this.formError">{{errorMessage}}</div>
    </transition>
    <form @submit.prevent="login" class="flexform">
      <input type="text" ref="username" name="username" v-model="input.username" placeholder="Email" />
      <input type="password" ref="password" name="password" v-model="input.password" placeholder="Password" />
      <input type="submit" value="Login" />
    </form>
    <p>Don't have an account? <router-link to="/register"><a>Register</a></router-link></p>
    <p>Forgot Password? <router-link to="/password/forgot"><a>Reset it</a></router-link></p>
  </div>
</template>


<style>
  .loginform {
    text-align: center;
  }
</style>

<script>
import DataUser from "@/js/data/controllers/DataUser";
import store from '@/store.js';

export default {
  name: 'LoginForm',
  data () {
    return {
      input: {
        username: '',
        password: ''
      },
      errorMessage: 'Invalid username/password combination',
      formError: false
    }
  },
  methods: {
    async login () {
      if (this.input.username === '') {
        alert('username is necessary')
        this.$refs.username.focus()
      } else if (this.input.password === '') {
        alert('password is required')
      } else {
        let params = {email: this.input.username, password: this.input.password}
        let data = await DataUser.login(params)
        if (data) {
          let apiToken = data.data.api_token
          this.$cookie.set('key', apiToken, 30)
          this.formError = false
          store.dispatch('setApiKey', apiToken)
          this.$router.push('/')
        }
        else {
          this.formError = true
        }
      }
    }
  }
}

</script>
